<template>
  <div class="u-text--outputfield" v-bind="$attrs">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import '../../styles/bonatitan/_global.scss'
import '../../styles/bonatitan/_variables.scss'
import '../../styles/bonatitan/u-text.scss'
</script>
